import { ReactElement } from 'react';

import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { medicalServicesMappingsTranslationKeys } from '../../translations';

import { AddNewMappingModalOpener } from './AddNewMappingModalOpener';

type MedicalServicesMappingsEmptyStatePlaceholderProps = {
   readonly onMappingCreateSuccess: VoidFunction;
};

export const MedicalServicesMappingsEmptyStatePlaceholder = (
   props: MedicalServicesMappingsEmptyStatePlaceholderProps
): ReactElement => {
   return (
      <EmptyStatePlaceholder
         testId={'noServiceMappings'}
         heading={medicalServicesMappingsTranslationKeys.noMappings}
         subheading={medicalServicesMappingsTranslationKeys.mapServicesToMakePatientsAbleToRegister}
      >
         <AddNewMappingModalOpener
            label={medicalServicesMappingsTranslationKeys.addNewMapping}
            onMappingCreateSuccess={props.onMappingCreateSuccess}
            withLeadingIcon={false}
            alreadySelectedServicesIds={undefined}
         />
      </EmptyStatePlaceholder>
   );
};
